<div class="dashboard">
  <section class="dashboard__header">
    <div class="dashboard__cards row g-3">
      <div class="col-12 col-sm-12 col-md-12" *ngIf="clientInfo?.coach.id && 
            !clientInfo?.dosage?.id && 
            clientInfo?.see_invitation_to_schedule">
        <div class="dashboard__card dashboard__initialcall">
          <p class="dashboard__initialcall-title" i18n>Agenda tu llamada inicial</p>
          <p class="text-center padding" i18n>Hemos asignado a <strong>{{clientInfo?.coach.name}}
              {{clientInfo?.coach.lastname}}</strong> como tu
            coach.<br>Accede ahora a su calendario y agenda tu llamada inicial.</p>
          <br />
          <a style="background-color:var(--BhavBlack);color: white; margin:0.5rem auto;padding: 0.7rem 3rem;"
            class="btn btn-schedule" [routerLink]="['/platform/schedule', clientInfo?.coach.id, 'appointments','.']"
            [href]="clientInfo.coach.calendly_url" i18n>Agendar llamada</a>
          <br />
          <p i18n>El propósito de esta llamada es revisar tu cuestionario para diseñar tu protocolo personalizado y
            darte la
            información que necesitas.</p>
          <p class="strong" i18n>Esta llamada no es una consulta o terapia.</p>
          <br />
          <p i18n>Si quieres complementar tu proceso con apoyo terapéutico pregunta a tu coach sobre las alternativas
            que podemos ofrecerte.</p>
          <br />
          <p class="text-center center-padding mt-2" style="font-size:14px;" i18n>Si
            ya has
            agendado llamada con el coach asignado, no te preocupes. Has caso omiso
            de este mensaje, pronto podrás iniciar tu tratamiento. Revisa <a [routerLink]="['/platform/appointments/.']"
              class="underlined">aquí</a> tus sesiones agendadas.</p>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4" *ngIf="clientInfo?.dosage && clientInfo?.dosage?.id else noProtocolAssigned">
        <div class="dashboard__card dashboard__protocol">
          <p class="dashboard__protocol-title" i18n>Mi Protocolo</p>
          <p class="dashboard__protocol-desc">{{ language === 'es' ? clientInfo?.dosage?.protocol_name :
            clientInfo?.dosage?.protocol_name_en }}</p>
          <a [routerLink]="['/platform', 'protocol', '.']" class="dashboard__link" i18n>Ir a mi protocolo &rarr;</a>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4" *ngIf="clientInfo?.coach?.id">
        <div class="dashboard__card dashboard__coach">
          <p class="dashboard__coach-title" i18n>Mi Coach</p>
          <div>
            <img [src]="clientInfo?.coach?.avatar" width="72" height="72" [alt]="clientInfo?.coach?.name"
              class="dashboard__coach-img" />
            <p class="dashboard__coach-name">{{clientInfo?.coach?.name}} {{clientInfo?.coach?.lastname}}</p>
          </div>
          <a [routerLink]="['/platform', 'inbox', '.']" class="dashboard__link" i18n>Envíale un mensaje &rarr;</a>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <div class="dashboard__card dashboard__sessions">
          <h3 class="dashboard__sessions-title" i18n>Tus próximas sesiones</h3>
          <ul class="dashboard__sessions-list">
            <ng-container *ngIf="nextAppointments.length > 0 && processing === false; else appointmentsEmptyList">
              <li *ngFor="let appointment of nextAppointments">
                <img [src]="appointment?.coach?.avatar" width="48" height="48" [alt]="appointment?.coach?.name"
                  class="dashboard__sessions-img" />
                <p><strong>{{appointment?.coach?.name}} {{appointment?.coach?.lastname}}</strong></p>
                <p>{{appointment.start_date | date : "d MMM hh:mm a z" : null : language }}</p>
              </li>
            </ng-container>
          </ul>
          <button [routerLink]="['/platform', 'appointments', '.']" class="dashboard__button" i18n>Ver todas tus
            sesiones</button>
        </div>
      </div>
      <!-- Using row and g-3 for gutter spacing -->
      <div class="col-12 col-sm-6 col-md-6">
        <div class="dashboard__card dashboard__intention">
          <h3 class="dashboard__intention-title" i18n>Tus intenciones</h3>
          <ng-container *ngIf="clientInfo?.protocols?.length">
            <div class="protocols">
              <p class="protocol-assigned" *ngFor="let protocol of clientInfo?.protocols">{{language === 'es' ? protocol.name : protocol.name_en}}</p>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6">
        <div class="dashboard__card dashboard__referrals">
          <h4 i18n>Referidos</h4>
          <p i18n>Promueve la salud integral con Bhavani. Comparte tu link con tus amigos y empieza a acumular 10% de
            descuento por cada referido.</p>
          <input type="text" [value]="referralLink" readonly>
          <button>Copiar liga de referidos</button>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12w">
        <div class="dashboard__card dashboard__followUpInvitation">
          <h4 i18n>¿Necesitas revisar tu proceso o conversar con tu coach?</h4>
          <p i18n>Este espacio está disponible para ti en cualquier momento del proceso.
            Si surge alguna duda o necesitas una orientación puntual, puedes escribirle a tu coach en cualquier momento
            durante tu recorrido.</p>
          <p i18n>
            En caso de que necesites revisar tu avance más a fondo, hacer ajustes guiados o integrar con mayor
            profundidad lo que estás viviendo, es altamente recomendable agendar una sesión uno a uno para recibir el
            acompañamiento adecuado.
            Muchos de nuestros usuarios encuentran en estas sesiones un punto de apoyo clave para sostener y enriquecer
            su camino.
          </p>
          <a class="btn" [routerLink]="['/platform', 'follow-up', 'plans', '.']" i18n>Ver planes de seguimiento</a>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-template #appointmentsEmptyList>
  <li>
    <p i18n>No tienes sesiones programadas.</p>
  </li>
</ng-template>

<ng-template #noProtocolAssigned>
  <div class="col-12 col-md-4">
    <div class="dashboard__card dashboard__protocol">
      <p class="dashboard__protocol-title" i18n>Mi Protocolo</p>
      <p class="dashboard__protocol-desc" i18n>Aún no tienes asignado un protocolo.</p>
      <!-- <a [routerLink]="['/platform', 'protocol', '.']" class="dashboard__link" i18n>Ir a mi protocolo &rarr;</a> -->
    </div>
  </div>
</ng-template>